import { createSelector } from 'reselect';

import { getPaging, getTextEditing, mountSelectorAt } from 'utils/selectors';
import { isSoonToBeLive, hasEnded } from 'forumLiveStatus';

const mount = mountSelectorAt('forum');

export const getForumThreadsIds = mount((localState, props) => {
  const { queryString, page } = props;
  const pagesForQuery = localState.forumThreads.byQuery[queryString];

  if(!pagesForQuery) {
    return [];
  }

  const forumThreadsIds = pagesForQuery.byPage[page];

  if(!forumThreadsIds) {
    return [];
  }

  return forumThreadsIds;
});

export const getForumThreadsById = mount(localState => localState.forumThreads.byId);

const forumThreadsSelectorMaker = () => {
  return createSelector(
    [getForumThreadsIds, getForumThreadsById],
    (forumThreadsIds, forumThreadsdById) => {
      return forumThreadsIds.map(id => {
        return forumThreadsdById[id];
      });
    }
  );
};

export const getForumThreadsOnFrontPage = forumThreadsSelectorMaker();

export const getForumThreadsOnSidebar = forumThreadsSelectorMaker();

export const getForumThreadsGrouped = createSelector(
  [getForumThreadsOnFrontPage],
  forumThreads => {
    const endedForumThreads = [];
    const currentlyLiveForumThreads = [];
    const startingSoonForumThreads = [];

    forumThreads.forEach(forumThread => {
      let group = currentlyLiveForumThreads;

      if(hasEnded(forumThread)) {
        group = endedForumThreads;
      }
      else if(isSoonToBeLive(forumThread)) {
        group = startingSoonForumThreads;
      }

      group.push(forumThread);
    });

    startingSoonForumThreads.reverse();
    return {
      endedForumThreads,
      currentlyLiveForumThreads,
      startingSoonForumThreads
    };
  }
);

export const getForumPaging = mount((localState, key, options) => getPaging(localState.paging[key], options));

export const getForumThread = mount((localState, id) => localState.forumThreads.byId[id]);

export const getForumContributeSubject = mount(localState => localState.contributeSubject);

export const getForumTextEditing = mount((localState, key) => getTextEditing(localState.textEditing[key]));

export const getForumEmojis = mount((localState, key) => localState.emojis[key]);

export const getForumStatus = mount(localState => localState.status);



/** WEBPACK FOOTER **
 ** ./src/members/state/forum/selectors.js
 **/